import React, { useEffect, useState } from "react";
import ConsentFormsList from "./ConsentFormsList";

const ConsentForms = () => {
  const [page, setPage] = useState<number>(
    parseInt(sessionStorage.getItem("consent-page") || "0") ?? 0
  );

  useEffect(() => {
    sessionStorage.setItem("consent-page", page.toString());
    return () => {
      sessionStorage.removeItem("consent-page");
    };
  }, [page]);

  return <ConsentFormsList formType="consent" page={page} setPage={setPage} />;
};

export default ConsentForms;
